import { render } from "./FooterNav.vue?vue&type=template&id=66d21f44&scoped=true"
import script from "./FooterNav.vue?vue&type=script&lang=js"
export * from "./FooterNav.vue?vue&type=script&lang=js"

import "./FooterNav.vue?vue&type=style&index=0&id=66d21f44&scoped=true&lang=css"

import exportComponent from "D:\\20231109nkGg7QhS(1)\\20231109nkGg7QhS\\vueweb\\vue-antd-tool-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66d21f44"]])

export default __exports__